const filterJobs = () => {
    const filterValues = {}
    const filterJobsCardData = {}
    const putDatasetToParentForCategorieInput = Array.from(document.querySelectorAll('.fake-select-input')).map(input => {
        if(!!input.querySelector('.category')) {
            input.querySelector('.fake-select-input__value').dataset['categories'] = input.querySelector('.category').dataset['categories']
        }
        return input
    })
    putDatasetToParentForCategorieInput.forEach(input => {
        if(input.id === 'job_category') {
            filterValues[input.id] = input.querySelector('.fake-select-input__value').dataset.categories
        } else {
            filterValues[input.id] = input.querySelector('.fake-select-input__value').dataset[input.id]
        }
    })
    Object.entries(filterValues).forEach(([key, value])=> {
        if (key ==='type_contract') {
            if (value.toLowerCase() === 'cdi' ) {
                filterJobsCardData.cdi = 1
                filterJobsCardData.cdd = 0
            } else if (value.toLowerCase() === 'cdd') {
                filterJobsCardData.cdi = 0
                filterJobsCardData.cdd = 1
            } else {
                filterJobsCardData.cdi = 'none'
                filterJobsCardData.cdd = 'none'
            }
        }
        if (key === 'time_contract') {
            if (value.toLowerCase() === 'full' ) {
                filterJobsCardData.fulltime = 1
                filterJobsCardData.parttime = 0
            } else if (value.toLowerCase() === 'half') {
                filterJobsCardData.fulltime = 0
                filterJobsCardData.parttime = 1
            } else {
                filterJobsCardData.fulltime = 'none'
                filterJobsCardData.parttime = 'none'
            }
        }
        if (key === 'job_category'){
            filterJobsCardData.categories = value
        }
        if (key === 'job_place'){
            filterJobsCardData.place = value.toLowerCase()
        }
    })
    filterJobsCards(filterJobsCardData)
}

function filterJobsCards(applyFilter) {
    document.querySelectorAll('.ia-block-listing-jobs__list__item').forEach(elem => elem.classList.remove('hide'))
    const filteredItem = Array.from(document.querySelectorAll('.ia-block-listing-jobs__list__item')).filter(item => {
        let correspondingJobsFilter = 0
        Object.entries(applyFilter).forEach(([key, value])=> {
            if (item.dataset[key].toLowerCase() === value.toString().toLowerCase() || value === 'none') {
                correspondingJobsFilter += 1
            }
        })
        if (correspondingJobsFilter === Object.keys(applyFilter).length) {
            return item
        }
    })
    document.querySelectorAll('.ia-block-listing-jobs__list__item').forEach(elem => elem.classList.add('hide'))
    filteredItem.forEach(elem => elem.classList.remove('hide'))
}

export {filterJobs}